import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { TonnageModule as _TonnageModule } from './pages/tonnage/tonnage.module';
import { TonnageRoutingModule } from './tonnage-routing.module';

@NgModule({
  imports: [
    CommonModule,
    TonnageRoutingModule,
    CoreModule,
    _TonnageModule
  ],
  declarations: [  ]
})
export class TonnageModule { }
